import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEn from './locals/en/translation.json';
import translationFr from './locals/fr/translation.json';
import { componentTranslations } from 'vopay';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        // we need to clone translations because imported files are mutable (we are updating 'translations' in useTranslationsOverride)
        originalTranslations: JSON.parse(JSON.stringify(translationEn)),
        translations: JSON.parse(JSON.stringify(translationEn)),
        components: componentTranslations.en,
      },

      fr: {
        originalTranslations: JSON.parse(JSON.stringify(translationFr)),
        translations: JSON.parse(JSON.stringify(translationFr)),
        components: componentTranslations.fr,
      },
      'fr-CA': {
        translations: translationFr,
      },
    },
    detection: {
      order: ['localStorage', 'sessionStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    ns: ['translations'],
    defaultNS: 'translations',
  });

export default i18n;
